import axios from 'axios'
import { BASE_URL, API_VERSION, SETTINGS } from '../endpoints'

export const GET_ALL_SETTINGS = 'GET_ALL_SETTINGS'
export const GET_SETTING = 'GET_SETTING'
export const ADD_SETTING = 'ADD_SETTING'
export const EDIT_SETTING = 'EDIT_SETTING'
export const DELETE_SETTING = 'DELETE_SETTING'
export const CLEAR_SETTING = 'CLEAR_SETTING'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${SETTINGS}?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_SETTINGS,
                payload: {
                    settings: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${SETTINGS}/${id}`, options)
        .then((response) => {

            dispatch({
                type: GET_SETTING,
                payload: {
                    setting: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItemLocal = (data) => (dispatch) => {
    dispatch({
        type: GET_SETTING,
        payload: {
            setting: data,
        }
    });
};


export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + accessToken,
        }
    }
    return axios.post(BASE_URL + SETTINGS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_SETTING, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + SETTINGS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_SETTING, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + SETTINGS + '/' + id, { value: payload }, apiHeader)
        .then(response => {
            dispatch({
                type: GET_SETTING,
                payload: {
                    setting: response.data.data[0],
                }
            });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const clearItem = () => (dispatch) => {
    dispatch({ type: CLEAR_SETTING });
}